import { EDtdResponse } from "@/types/backoffice/dto/dtd/dtd-response-dto.ts";

const dtdLocale = {
  dtd: {
    pageTitle: "RIP",
    title: "RIP : Résolution de l'Inconfort lié au Pilotage en Température",
    concernedRoom: "La pièce concernée",
    inconfortTime: "Heure de l'inconfort",
    inconfortType: "Type d'inconfort",
    hot: "Chaud",
    cold: "Froid",
    analyse: "Analyser",
    proposedActions: "Actions proposées",
    beforeDiagnosis: "Avant d'effectuer un diagnostic :",
    askTemperature: "Demander la température de consigne sur l'écran (ou chiffre de la molette)",
    checkRadiator: 'Vérifier que le radiateur est sur le mode "Programmation Externe"',
    dtdAnalysis: "RIP ANALYSIS",
    analysis: {
      [EDtdResponse.SITE_NOT_VX]:
        "Le site sélectionné est équipé avec une ancienne gamme (v2-v5). L’analyse n’est pas possible.",
      [EDtdResponse.HAVE_GE]:
        "Un Gestionnaire d'Energie externe (non Voltalis) a été détecté.\n" +
        "\n" +
        "Pour rappel, un gestionnaire d'énergie externe est un thermostat (connecté ou non), un programmateur, un régulateur qui permet de piloter les radiateurs (hors solution Voltalis)",
      [EDtdResponse.HAVE_PAC]:
        "Le pilotage en température pour une pompe à chaleur nécessite un capteur de température. ",
      [EDtdResponse.TEMPERATURE_ACQUISITION_CT_NOT_OK_NOW_OK]:
        " La collecte des données du capteur tiers ne permet pas de valider le pilotage à distance.",
      [EDtdResponse.TEMPERATURE_ACQUISITION_CT_NOT_OK_NOW_NOT_OK]:
        " La collecte des données du capteur tiers ne permet pas de valider le pilotage à distance.",
      [EDtdResponse.TEMPERATURE_ACQUISITION_MODULATOR_NOT_OK_NOW_OK]:
        " La collecte des données de consommation ne permet pas de valider le pilotage à distance, le dispositif est donc passé dans un mode de régulation de secours moins performant pendant cette période.",
      [EDtdResponse.TEMPERATURE_ACQUISITION_MODULATOR_NOT_OK_NOW_NOT_OK]:
        " La collecte des données de consommation ne permet pas de valider le pilotage à distance, le dispositif est donc passé dans un mode de régulation de secours moins performant pendant cette période.",
      [EDtdResponse.RECENT_DISCOMFORT_AND_VOLTALIS_DOESNT_CONTROL]:
        "Le module est bien connecté à notre plateforme mais il n’est pas en mesure de piloter votre appareil.",
      [EDtdResponse.NO_CONSUMPTION_FOUND]:
        " La consommation relevée est trop faible pour dégager de la chaleur. L’inconfort n’est pas liée au radiateur équipée par la solution Voltalis.\n",
      [EDtdResponse.NO_TEMPERATURE_CONTROL]: "L’adhérent n’a pas utilisé le mode Température sur la période donnée.",
      [EDtdResponse.VERSION_IS_OUT_OF_DATE]: "Le module de communication n’est pas à jour. ",
      [EDtdResponse.NO_PROBLEM_FOUND]:
        " Aucune anomalie détectée lors du pilotage à l’aide du capteur de température. ",
      [EDtdResponse.CALIBRATION_NEEDED_HOT]:
        "Une calibration est nécessaire. \n" + "Dernière calibration adhérent: Pas de calibration. ",
      [EDtdResponse.CALIBRATION_NEEDED_COLD]:
        "Une calibration peut être nécessaire. \n" + "Dernière calibration adhérent: Pas de calibration. ",
      [`${EDtdResponse.CALIBRATION_NEEDED_HOT}_WITH_PROPERTIES`]:
        "Une calibration est nécessaire. \n" +
        "Dernière calibration adhérent: {lastCalibrationTemperature}°C le {lastCalibrationDate}. ",
      [`${EDtdResponse.CALIBRATION_NEEDED_COLD}_WITH_PROPERTIES`]:
        "Une calibration peut être nécessaire. \n" +
        "Dernière calibration adhérent: {lastCalibrationTemperature}°C le {lastCalibrationDate}. ",
      [EDtdResponse.IMPOSSIBLE_DIAGNOSIS]: "Diagnostic impossible.",
    },
    action: {
      [EDtdResponse.SITE_NOT_VX]: "",
      [EDtdResponse.HAVE_GE]: "Veuillez demander à l'adhérent de le désactiver ou le mettre sur confort (ou soleil)",
      [EDtdResponse.HAVE_PAC]: "Merci de faire une demande d’envoi de capteur tiers pour ce site.",
      [EDtdResponse.TEMPERATURE_ACQUISITION_CT_NOT_OK_NOW_OK]:
        " La communication a été rétablie depuis, demandez si l'inconfort est toujours en cours chez l'adhérent, si oui, relancer le diag RIP avec une période plus récente.",
      [EDtdResponse.TEMPERATURE_ACQUISITION_CT_NOT_OK_NOW_NOT_OK]:
        "Contrôler la bonne communication du capteur tiers, si pas de problème identifié, Escalader ce site en “Assistance technique - Non urgent” en précisant : #RIP, La pièce concernée, Le code ACQ_CT.",
      [EDtdResponse.TEMPERATURE_ACQUISITION_MODULATOR_NOT_OK_NOW_OK]:
        "La communication a été rétablie depuis, demandez si l'inconfort est toujours en cours chez l'adhérent, si oui, relancer le diag RIP avec une période plus récente",
      [EDtdResponse.TEMPERATURE_ACQUISITION_MODULATOR_NOT_OK_NOW_NOT_OK]:
        " Contrôler la bonne communication du dispositif.",
      [EDtdResponse.RECENT_DISCOMFORT_AND_VOLTALIS_DOESNT_CONTROL]:
        " Inviter l’adhérent(e) à mettre son radiateur sur “Programmation Externe” et réaliser un “Diagnostic” dans un VoltaCall",
      [EDtdResponse.NO_CONSUMPTION_FOUND]:
        "Inviter l'adhérent à contrôler les autres sources de chaleur : planchers chauffant, poêle à bois, cheminée, exposition au soleil etc.",
      [EDtdResponse.NO_TEMPERATURE_CONTROL]:
        " Sélectionner une période différente. Sinon, inviter l’adhérent a utiliser le mode température et revenir vers l’Assistance en cas d’inconfort.",
      [EDtdResponse.VERSION_IS_OUT_OF_DATE]: "Escalader au niveau 2.",
      [EDtdResponse.NO_PROBLEM_FOUND]:
        "Niveau 1: \n" +
        "Vérifier auprès de l’adhérent si le capteur tiers respecte les consignes d’installations: dans la pièce du radiateur, dégagé à hauteur d’homme, non exposé au soleil.\n" +
        "Demander la température de confort ou niveau de la mollette consigne ou la molette directement sur le radiateur: \n" +
        "Si Inférieure à 15 °C ou mollette <2 ? L’inconfort est non lié à Voltalis. Inviter à augmenter la température de confort. \n" +
        "Si non, escalader le dossier à l’assistance N2\n" +
        "Niveau 2: escalader le dossier au services études en précisant la pièce concernée, la date de l’inconfort ainsi que le type d’inconfort.",
      [EDtdResponse.CALIBRATION_NEEDED_HOT]:
        "Niveau 1: Réaliser la calibration si l’adhérent n’a pas calibré ou a calibré avant l’inconfort. Si non, escalader le dossier à l’assistance N2.\n" +
        "Niveau 2: escalader le dossier au services études en précisant la pièce concernée, la date de l’inconfort ainsi que le type d’inconfort.",
      [EDtdResponse.CALIBRATION_NEEDED_COLD]:
        "Niveau 1: Demander la température de confort ou niveau de la mollette consigne ou la molette directement sur le radiateur.\n" +
        "Inférieure à 15 °C ou mollette <2 ? → Inconfort non lié à Voltalis et inviter à augmenter la température de confort.\n" +
        "Si non, réaliser la calibration si l’adhérent n’a pas calibré ou a calibré avant l’inconfort. \n" +
        "Si non, escalader le dossier à l’assistance N2.\n" +
        "Niveau 2: escalader le dossier au services études en précisant la pièce concernée, la date de l’inconfort ainsi que le type d’inconfort.",
      [EDtdResponse.IMPOSSIBLE_DIAGNOSIS]:
        "Niveau 1: escalader le dossier à l’assistance N2\n" +
        "Niveau 2: escalader le dossier au services études en précisant la pièce concernée, la date de l’inconfort ainsi que le type d’inconfort.",
    },
    calibration: {
      noCalibrationTemperature: "Aucune temperature trouvée",
      noCalibrationDate: "Aucune date n'a été trouvée",
      calibrationTemperatureError: "Une erreur de calibration a été trouver, aucune température de renseigné",
      calibrationDateError: "Une erreur de calibration a été trouver, aucune date de renseigné",
    },
    error: {
      errorOccurred: "Une erreur est survenue",
      errorPleaseRetry: "Une erreur s'est produite, merci de réessayer ultérieurement",
    },
  },
};

export type DtdLocale = typeof dtdLocale;
export default dtdLocale;
